<template>
  <v-navigation-drawer
    :model-value="show"
    temporary
    location="right"
    :width="500"
    class="bg-background pa-2"
    @update:model-value="inputChanged"
  >
    <list-header>
      <template #viewToggle>
        <sf-icon-button
          color=""
          :icon="mdiArrowCollapseRight"
          :aria-label="$t('closeErrorOrders')"
          @click="emit('close')"
        />
      </template>
      <template #action>
        <sf-text-button :aria-label="$t('archiveAll')" @click="archiveAll">
          <v-icon :size="32" :icon="mdiArchive" />
          {{ $t('archiveAll') }}
        </sf-text-button>
      </template>
    </list-header>
    <orders-grid-column-header
      :order-status="column.orderStatus"
      :count="column.count"
      :loading="column.loading"
      badge-color="error"
    />
    <orders-grid-column :column="column" />
  </v-navigation-drawer>
</template>

<script setup lang="ts">
import SfIconButton from '@/components/button/SfIconButton.vue'
import SfTextButton from '@/components/button/SfTextButton.vue'
import ListHeader from '@/components/list/ListHeader.vue'
import OrdersGridColumn from '@/modules/order/components/OrdersGridColumn.vue'
import OrdersGridColumnHeader from '@/modules/order/components/OrdersGridColumnHeader.vue'
import { OrderPreviewColumn } from '@/modules/order/types'
import useOrderPreviews from '@/modules/order/useOrderPreviews'
import { mdiArchive, mdiArrowCollapseRight } from '@mdi/js'
import { PropType } from 'vue'

defineProps({
  show: {
    type: Boolean,
    required: true
  },
  column: {
    type: Object as PropType<OrderPreviewColumn>,
    required: true
  }
})

const emit = defineEmits<{
  (e: 'close'): void
}>()

const inputChanged = (value: boolean) => {
  if (!value) {
    emit('close')
  }
}

const archiveAll = () => {
  useOrderPreviews().archiveAllErrorOrders()
  emit('close')
}
</script>
